import { defineNuxtPlugin } from '#imports';
import { start, finish } from '~/composables/use-loading';
import { useCartStore } from '~/stores/cart';
import type { FetchOptions, $Fetch } from 'ofetch';

export default defineNuxtPlugin(() => {
  const cartStore = useCartStore();
  const shopBackendApiOptions: FetchOptions = {
    headers: {
      Accept: 'application/vnd.td.eg-solo.v1+json',
      'Content-Type': 'application/json',
    },
    onResponse({ response }) {
      const csrfToken = response.headers.get('x-csrf-token');
      if (csrfToken) {
        cartStore.setCsrfToken(csrfToken);
      }
      finish();
    },

    onRequest({ options }) {
      if (options.loadingSpinner !== false) {
        start();
      }
      if (options.noSession !== true && cartStore.csrfToken) {
        if (!options.headers) {
          options.headers = new Headers();
        }
        (options.headers as Headers).set('x-csrf-token', cartStore.csrfToken);
      }
    },
    onResponseError({ response }) {
      const csrfToken = response?.headers?.get('x-csrf-token');
      if (csrfToken) {
        cartStore.setCsrfToken(csrfToken);
      }
      finish();
    },
    onRequestError(context) {
      finish();
    },
  };
  const shopBackendApi: $Fetch = $fetch.create(shopBackendApiOptions);

  return {
    provide: {
      shopBackendApi,
    },
  };
});
